<template>
  <div class="pa-3">
    <div>
        <v-text-field
        :placeholder="'Put your ' + this.inventory.txt_label + ' here'"
        v-model="inventory.body[inventory.key_profile]"
        hide-details
        class="rounded-lg my-1"
        outlined
        :type="this.inventory.key_profile == 'phone_number' ? 'number': ''"
        ></v-text-field>
        <div class="mt-5 d-flex justify-end">
          <v-btn 
            depressed 
            color="#016443" 
            class="text-capitalize"
            dark 
            @click="updateData"
            >Save</v-btn>
      </div>
    </div>
    <v-overlay :absolute="true" color="white" opacity="1" :value="loading">
      <v-progress-circular
        indeterminate
        class="mr-2"
        color="#006341"
      ></v-progress-circular>
      <b class="color_default">Loading...</b>
    </v-overlay>
  </div>
</template>

<script>
import { mapState } from "vuex";
export default {
  components: {
  },
  name: "profile",
  props: ["inventory"],
  computed: {
    ...mapState({
      role: (state) => state.role,
      permissions: (state) => state.permissions,
      ava: (state) => state.ava,
    }),
  },
  data() {
    return {
      loading: false,
    };
  },
  mounted(){
  },
  methods: {
    updateData() {
      this.loading = true;
      let body = new FormData();
      body.append("id", this.inventory.id);
      body.append([this.inventory.key_profile], this.inventory.body[this.inventory.key_profile]);

      let data = {
        path: `manage/scholar/update`,
        body: body,
      };

      this.$store
        .dispatch("user/postApi", data)
        .then((data) => {
          this.$store.dispatch("notify", {
            msg: data.message,
            type: "success",
          });
          this.$emit("success");
          this.loading = false;
        })
        .catch((e) => {
          this.$store.dispatch("notify", {
            msg: e.message,
            type: "error",
          });
          this.loading = false;
        });
    },
  },
};
</script>

<style scoped></style>
